import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAqbIDCMLIdP0AGN9-W5H-AQ3Nq5D5LQv8",
  authDomain: "adluck-d640d.firebaseapp.com",
  projectId: "adluck-d640d",
  storageBucket: "adluck-d640d.appspot.com",
  messagingSenderId: "432225497585",
  appId: "1:432225497585:web:a4b58a226a9f50a14d5450",
  measurementId: "G-HV3G7NRHCF"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { db, auth, firebaseConfig };